/**
 * Controllers
 * @module controllers
 */
define(function (require, exports) {
    'use strict';

    /** @type {ng.IAngularStatic} */
    var angular = require('angular');
    //var $ = require('jquery');
    var _ = require('lodash');
    var sdkinit = require('XmSdk');
    //var sdkui = require('metro-module-sdkui');
    var sdk = new sdkinit.XmSdk();

	//CR 68 changes
    var waitableTicket = require("../../widget-metro-soft-token/scripts/waitableTicket")
    // @ngInject
    /**
     * @param {ng.IScope} $scope
     * @param {ng.ILocationService} $location
     */
    exports.MainCtrl = function ($scope, $sce, $location, securityCodeService, lpUsersAuthentication, lpCoreBus, lpWidget, lpCoreUtils, tulipProvider,metroToggle,$http, metroTagging, metroMeta, idleTimeout,metToggle,metroUtils, metroTransmit) {
        var inWidgetNotificationId = lpWidget.getPreference('inWidgetNotificationId');
        lpCoreBus.subscribe('tulip:publish-session-id', function(fraudSessionId) {
            $scope.$evalAsync(function() {
                $scope.fraudSessionId = fraudSessionId;
            });
        });
        $scope.invalidibid = false;
        $scope.ordinal = ['st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th'];
        $scope.step = 1;
        $scope.submitted = false;
        $scope.customer = {
            code: []
        };
        $scope.seedPositionsLoading = false;

        $scope.showTotpInput = false;

        var renderTemplate = function (header, text, phone) {
            return '<h3 style="text-align: left; font-size: 20px; margin: 8px 0; padding: 0 8px; color:white;">' + header + '</h3>' +
                '<p style="margin: 0 0 10px; text-align: left; padding: 0 8px; line-height: 19px; border-bottom: 0; width: 200px;">' + text + '<br><b>' + phone + '</b></p>';
        };

        // help & info and store locator links
        $scope.pageId = lpWidget.getPreference('pageId');
        $scope.cobOutage = lpWidget.getPreference('cobOutage');
        $scope.cobOutageHeading = lpWidget.getPreference('cobOutageHeading');
        $scope.cobOutageMessage = lpWidget.getPreference('cobOutageMessage');
        $scope.storeLocatorUrl = lpWidget.getPreference('storeLocatorLink');
        $scope.helpAndInfoUrl = lpWidget.getPreference('helpAndInfoLink');
        $scope.contactUsTooltip = lpWidget.getPreference('contactUsTooltip');
        $scope.contactUsHeader = lpWidget.getPreference('contactUsHeader');
        $scope.contactUsText = lpWidget.getPreference('contactUsText');
        $scope.contactUsPhone = lpWidget.getPreference('contactUsPhone');
        $scope.contactUsTooltip = $sce.trustAsHtml(renderTemplate(
            $scope.contactUsHeader, $scope.contactUsText,
            $scope.contactUsPhone));
        $scope.redirectToOnLoginSuccess = lpWidget.getPreference('announcementsUrl');
        $scope.UserBindModal = false;
        var ctrl = this;
        var resolvePromise = {};
        var resolveSoftTokenPromise = {};
        $scope.rejectJourney = false;

        var CurrentDate = new Date();
        var lastdatetoshowmsg = new Date('2025-06-09 23:00:00');
        if(!document.getElementById('topmsg') && !localStorage.getItem('session')  && CurrentDate <= lastdatetoshowmsg){
            angular.element('.lp-navbar-advanced:first').append("<marquee scrollamount='12' onMouseOver='this.stop()' onMouseOut='this.start()' id='topmsg' vspace='5px'  style='color:white;font-size:18px;'><i><b>Unable to log in?</b> If you use the Metro Bank Authenticator App, you’ll need to upgrade to the latest version to continue using it from <b>7 May 2025</b>. To upgrade visit the <a href='https://apps.apple.com/gb/app/metro-bank-authenticator/id1524446800' target='_blank' ><b>Apple App Store</b></a> or <a href='https://play.google.com/store/search?q=metro+bank+authenticator+app&c=apps' target='_blank' ><b>Google Play Store</b></a>, search for the ‘Metro Bank Authenticator App’ and select ‘update’.</i></marquee>");
        }
        if(localStorage.getItem('session') && document.getElementById('topmsg')){
            angular.element('#topmsg').remove();
        }
        
        /* Checking for Account locked Scenarios in Payment & HRP */
        if(window.location.search && window.location.search.indexOf('locked=true') > -1) {
            let error = {notification:{title:"LOGIN_FAILURE_LOCKED_OUT",show:true,showDetail:false,level:"error",icon:"close",id:"LOGIN_FAILURE_LOCKED_OUT",category:"security"}};
            lpCoreBus.publish('launchpad.add-notification',error);
        }

        /* Checking for Account locked Scenarios in Payment & HRP */
        if(window.location.search && window.location.search.indexOf('inactiveqr=true') > -1) {
            let qrerror = {notification: {
                    category: 'security',
                    id: 'SESSION_EXPIRED',
                    level: 'severe',
                    icon: 'lock',
                    message: 'You\'ve been signed out due to inactivity.\nFor your security we\'ve signed you out of your Business banking session because you haven\'t been active for the last 15 minutes.',
                    closable: true
                }};
            lpCoreBus.publish('launchpad.add-notification',qrerror);
        }

        /* Transmit SDK code */
        $scope.initiazeSDK = function() {
            ctrl.idleTimeout ? ctrl.idleTimeout.resetTime() : '';
            const endpoint = configData.scaUrl;
            const appID = configData.appId;
            let doubleEncryption = configData.doubleEncryptionEnabled;
            let connectionSettings;
            if (doubleEncryption=="N")
            {
                connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.create(endpoint, appID);
            } else {
                connectionSettings = com.ts.mobile.sdk.SDKConnectionSettings.createWithCryptoMode(endpoint, appID,null, null, com.ts.mobile.sdk.ConnectionCryptoMode.Credentials);
            }
            sdk.setConnectionSettings(connectionSettings);
            metroTransmit.reinitialize();
            $scope.resetJsonProviderData();
        }

        $scope.contentSoftotokeUIHandler = function(isBioDisabled){
            if(isBioDisabled) {
                $scope.isBiomatricDisabled = true;
                angular.element(".biomatricEnabled").hide();
                angular.element(".biomatricDisabled").show();
            }
            else{
                $scope.isBiomatricDisabled = false;
                angular.element(".biomatricEnabled").show();
                angular.element(".biomatricDisabled").hide();
            }
        }


        function CustomUIHandler() {
         //   sdkinit.XmUIHandler.call(this);
        }

       // CustomUIHandler.prototype = Object.create(sdkinit.XmUIHandler.prototype);
        CustomUIHandler.prototype.constuctor = CustomUIHandler;

         //############# Start BaseAuthenticatorSession prototype

        function BaseAuthenticatorSession (title, username, common) {
                this.supportsInlineError = false;
                this.title = title;
                this.username = username;
                this.common = common;
            }

            BaseAuthenticatorSession.prototype.baseConstructor = function(title, username, common) {
                this.supportsInlineError = false;
                this.title = title;
                this.username = username;
                this.common = common;
            }
        BaseAuthenticatorSession.prototype.startSession = function(description, mode, actionContext, clientContext) {
                this.description = description;
                this.mode = mode;
                this.actionContext = actionContext;
                this.clientContext = clientContext;
                this.common.log(`Starting session; session mode: [${this.mode}], authenticator: [${this.title}]`);
            }
        BaseAuthenticatorSession.prototype.changeSessionModeToRegistrationAfterExpiration = function() {
                this.common.log(`Changing session mode to registration after expiration; authenticator: [${this.title}]`);
                this.mode = com.ts.mobile.sdk.AuthenticatorSessionMode.Registration;
                this.authError = null;
            }
        BaseAuthenticatorSession.prototype.promiseRecoveryForError = function(error, validRecoveries, defaultRecovery) {
                this.common.log(`Starting error recovery; session mode: [${this.mode}], authenticator: [${this.title}], error: [${error}]`);
                if (this.supportsInlineError && defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator) {
                    this.authError = error;
                    return Promise.resolve(defaultRecovery);
                }
                else if (defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.Fail) {
                    return Promise.resolve(defaultRecovery);
                }
                return this.common.promiseRecoveryForError(error, validRecoveries, defaultRecovery, this.clientContext);
            }
        BaseAuthenticatorSession.prototype.endSession = function() {
                this.common.log(`Ending session; session mode: [${this.mode}], authenticator: [${this.title}]`);
            }
        BaseAuthenticatorSession.prototype.promiseInput = function() {
                //this.common.setAriaBusy(this.clientContext);
                let promise;
                switch (this.mode) {
                    case com.ts.mobile.sdk.AuthenticatorSessionMode.Authentication:
                        this.common.log(`Fetching authentication input; authenticator: [${this.title}]`);
                       // this.common.unsetAriaBusy(this.clientContext);
                        promise = this.promiseAuthInput();
                        break;
                    case com.ts.mobile.sdk.AuthenticatorSessionMode.Registration:
                        this.common.log(`Fetching registration input; authenticator: [${this.title}]`);
                       // this.common.unsetAriaBusy(this.clientContext);
                        promise = this.promiseRegInput();
                        break;
                }
                return promise.then((input) => {
                    //this.common.clearContainer(this.clientContext);
                return input;
            });
            }
        //############# End BaseAuthenticatorSession prototype

        //############# start createFormSession prototype
        CustomUIHandler.prototype.createFormSession = function (formId, payload) {
            function FormSession(formId, payload, common) {
                this.formId = formId;
                this.payload = payload;
                this.common = common;
            }
            FormSession.prototype.getContainer = function (clientContext) {
                return xmui.XmUIHandler.getContainer(clientContext);
            }
            FormSession.prototype.startSession = function (clientContext, actionContext) {
                this.actionContext = actionContext;
                this.clientContext = clientContext;
            }

            FormSession.prototype.promiseFormInput = function () {
                switch (true) {
                    case (this.formId === "seed_positions_form"):
                        return this.renderPasswordSeedForm();
                    case (this.formId === "hard_token_form"):
                        return this.renderHardtokenForm();
                    case (this.formId === "user-bind-confirmation-form"):
                        return  this.renderBindUserForm();
                    case (this.formId === "fake_soft_token_form"):
                            return this.renderFakeSoftTokenForm();
                            //CR 68 changes
                    case (this.formId === "cob_mobile_auth_registration_form"):
                        return this.renderRegistrationForm();

                    default:
                        return this.renderForm();
                }
            };

            FormSession.prototype.renderFakeSoftTokenForm = function () {
                //var _this = this;
                $scope.fakeSoftTokenForm = true;
                $scope.customer.passcode = "";
                $scope.showTotpInput = false
                $scope.softokenLoading = false;
                $scope.step = 4;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
                return new Promise(function (resolve, reject) {
                    resolvePromise = {
                        "resolve": resolve,
                        "reject": reject
                    }
                })
            }
			//CR 68 changes
            FormSession.prototype.renderRegistrationForm = function(){
                var _this = this;
                $scope.stopLoader = true;
                $scope.QRObject =_this.payload;
                $scope.hardtokenLoading = false;
                $scope.RegistrationStep = 1;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
                return new Promise(function (resolve, reject) {
                    resolvePromise = {
                        "resolve": resolve,
                        "reject": reject
                    }
                })
            }


            FormSession.prototype.renderPasswordSeedForm = function () {
                var _this = this;
                //var uiContainer = _this.clientContext.uiContainer;
                submitCustomerNo();
                $scope.hardtokenLoading = false;
                focusElement('customerPassword');
                $scope.securityCode = formatSeedPosiotions(_this.payload.seed_positions);
                $scope.seedPositionsLoading = false;
                $scope.disabledSoftoken = false;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
                metroTagging.onpageLoadTag(
                    metroMeta.LOGINPAGE.seedsPage,
                    metroMeta.LOGINPAGE.loginUrl,
                    metroMeta.EVENT.pageLoaded);

                return new Promise(function (resolve, reject) {
                    resolvePromise = {
                        "resolve" : resolve,
                        "reject" : reject
                    }
                })
            }

            FormSession.prototype.renderHardtokenForm = function () {
                var _this = this;
                $scope.showHardTokenPage = true;
                $scope.customer.hardTokenNo = "";
                $scope.step = 3;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
                focusElement('hardTokenNo');
                metroTagging.onpageLoadTag(
                    metroMeta.LOGINPAGE.hardTokePage,
                    metroMeta.LOGINPAGE.loginUrl,
                    metroMeta.EVENT.pageLoaded);

                $scope.actionContext=this.actionContext;

                return new Promise(function (resolve, reject) {
                    resolvePromise = {
                        "resolve" : resolve,
                        "reject" : reject
                    }
                    $scope.session_id = _this.payload.session_id;

                })
            }



            FormSession.prototype.renderBindUserForm = function(){
                var _this = this;
                $scope.showUserBindModal = true;
                $scope.isAttemptExceed = _this.payload.warning
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
                metroTagging.onpageLoadTag(
                    metroMeta.LOGINPAGE.bindPopupPage,
                    metroMeta.LOGINPAGE.loginUrl,
                    metroMeta.EVENT.pageLoaded);

                return new Promise(function (resolve, reject) {
                    resolvePromise = {
                        "resolve" : resolve,
                        "reject" : reject
                    }
                })
            }
            FormSession.prototype.renderForm = function () {
            };
            FormSession.prototype.onContinue = function (payload) {
            };
            FormSession.prototype.onError = function (payload) {
                console.log("error")
            };
            FormSession.prototype.endSession = function () {
            };
            return new FormSession(formId, payload, this.common);
        };
        //############# end createFormSession prototype
        CustomUIHandler.prototype.selectAuthenticatorFallbackAction = function (validOptions, fallbackAuthenticator, session, actionContext, clientContext) {
            return new Promise(function (resolve, reject) {
                $scope.softokenError = true
                resolve({ abortSelection: true });
            })
        }

        CustomUIHandler.prototype.selectAuthenticator = function (options, actionContext, clientContext) {
            $scope.contentSoftotokeUIHandler(false)
            return new Promise(function(resolve, reject) {
                if( options && options.length > 0){
                    var option;
                    var optionvalues = options;
                    optionvalues.forEach(function(op){
                        var authenticator = op.getAuthenticator();
                        if( authenticator["_authenticatorId"] == "totp" ){
                            option = op;
                        }
                    })
                    if(!option){
                        if($scope.isFirstFactorAuthenticationFailed){
                            $scope.softokenErrorMessage.biomatricDisabled = true
                            resolve(com.ts.mobile.sdk.AuthenticatorSelectionResult.createAbortRequest());
                        }
                        else{
                            $scope.contentSoftotokeUIHandler(true)
                            if (!$scope.$$phase) {
                                $scope.$apply();
                            }
                        }
                    }else{
                        var authenticator = option.getAuthenticator();
                        resolve(com.ts.mobile.sdk.AuthenticatorSelectionResult.createSelectionRequest(authenticator));
                    }
                }
            });
        }

        $scope.resetJsonProviderData = function(){
            ctrl.isMobileRegister = "";
            $scope.login_cross_session_id = "";
            $scope.mobile_auth_reg_cross_session_id = "";
            $scope.softokenErrorMessage = "";
            $scope.isFirstFactorAuthenticationFailed = ""
        }

        CustomUIHandler.prototype.processJsonData = function (jsonData) {
            //To Do clear all json Data when journey start
            if(jsonData.promote_mobile_authenticator) {
                ctrl.isMobileRegister  =  jsonData.promote_mobile_authenticator.promote_mobile_authenticator
            }
            if(jsonData.login_cross_session_id){
                $scope.login_cross_session_id  = jsonData.login_cross_session_id
            }
			//CR 68 changes
            if(jsonData.mobile_auth_reg_cross_session_id){
                $scope.mobile_auth_reg_cross_session_id  = jsonData.mobile_auth_reg_cross_session_id
            }
            if(jsonData.is_fake_journey){
                $scope.softokenErrorMessage = jsonData.lock_rule_response;
                $scope.isFirstFactorAuthenticationFailed = true;
            }

            if(jsonData.sca_soft_token_enabled) {
                enabledSoftoken(true);
             }
             else {
                 enabledSoftoken(false);
             }

            return Promise.resolve(com.ts.mobile.sdk.JsonDataProcessingResult.create(true))
        }

        var enabledSoftoken = function (flag) {
            if(flag) {
                $('.scaenabled-flag4').remove();
            }
            else {
                $('.scadisabled-flag4').remove();
            }
        }

        var MobileApproveAuthenticationState;
        (function (MobileApproveAuthenticationState) {
            MobileApproveAuthenticationState[MobileApproveAuthenticationState["TargetSelection"] = 0] = "TargetSelection";
            MobileApproveAuthenticationState[MobileApproveAuthenticationState["PollingRequested"] = 1] = "PollingRequested";
            MobileApproveAuthenticationState[MobileApproveAuthenticationState["PollingStarted"] = 2] = "PollingStarted";
        })(MobileApproveAuthenticationState || (MobileApproveAuthenticationState = {}));

        CustomUIHandler.prototype.createMobileApproveAuthSession = function (title, username, instructions){

            function MobileApproveAuthenticatorSession(){}
            MobileApproveAuthenticatorSession.prototype = Object.create(BaseAuthenticatorSession.prototype);

             MobileApproveAuthenticatorSession.prototype.constructor= function(title, username, instructions, common = console) {

                console.log("++++++++++++++++++++MobileApproveAuthenticatorSession")
                this.state = MobileApproveAuthenticationState.TargetSelection;
                this.pollingIntervalMillis = 3000;
                this.instructions = instructions;

                this.baseConstructor(title, username, common);

                return this;
            }
            MobileApproveAuthenticatorSession.prototype.startSession = function(description, mode, actionContext, clientContext) {
                this.description = description;
                this.mode = mode;
                $scope.actionContext=actionContext;
                this.clientContext = clientContext;
                this.common.log(`MobileApproveAuthenticatorSession: Starting session; session mode: [${this.mode}], authenticator: [${this.title}]`);
            }

            MobileApproveAuthenticatorSession.prototype.setPollingIntervalInMillis = function(millis) {
                this.pollingIntervalMillis = millis;
            }
            MobileApproveAuthenticatorSession.prototype.setCreatedApprovalInfo = function(targets, otp) {
                if (targets != null) {
                    this.createdForTargets = targets;
                    this.otp = otp;
                    this.state = MobileApproveAuthenticationState.PollingRequested;
                }
                else {
                    this.createdForTargets = null;
                    this.otp = null;
                    this.state = MobileApproveAuthenticationState.TargetSelection;
                    clearTimeout(this.pollingTimer);
                    this.hidePendingUi();
                }
            }
            MobileApproveAuthenticatorSession.prototype.setAvailableTargets = function(targets) {
                this.availableTargets = targets;
            }
            MobileApproveAuthenticatorSession.prototype.endSession= function() {
                clearTimeout(this.pollingTimer);
               // this.common.clearContainer(this.clientContext);
            }
            MobileApproveAuthenticatorSession.prototype.promiseInput = function() {
                switch (this.mode) {
                    case com.ts.mobile.sdk.AuthenticatorSessionMode.Authentication:
                       // this.common.setAriaBusy(this.clientContext);
                        this.common.log("Fetching Mobile Approve authentication input;");
                        switch (this.state) {
                            case MobileApproveAuthenticationState.TargetSelection:
                                return this.promiseTargetSelectionInput();
                            case MobileApproveAuthenticationState.PollingRequested:
                                this.state = MobileApproveAuthenticationState.PollingStarted;
                                this.promisePendingUI().then((input) => {
                                    clearTimeout(this.pollingTimer);
                                this.hidePendingUi();
                                if (this.currentPollingResolver) {
                                    this.currentPollingResolver(input);
                                    this.currentPollingResolver = null;
                                }
                                else {
                                    this.pendingCancelRequest = input;
                                }
                        });
                        return this.startPolling();
                    case MobileApproveAuthenticationState.PollingStarted:
                        return this.startPolling();
                    default:
                                return Promise.reject("Illegal state");
                }
                case com.ts.mobile.sdk.AuthenticatorSessionMode.Registration:
                    throw new Error("Method not implemented.");
                }
            }
            MobileApproveAuthenticatorSession.prototype.promiseTargetSelectionInput = function() {
                let authMobileAuthSelectDeviceForm = $('<div class="xmuiCore xmuiForm xmuiMobileAuthSelectDeviceForm">\
                <div class="xmuiPrompt" data-xmui-customstringtext="mobileAuthDeviceSelection.selectDevices"/>\
                <div class="xmuiFullHeightContentBelowPrompt xmuiAuthMobileDeviceSelection">\
                    <div class="xmuiAuthMobileDeviceSelectionList"></div>\
                    <div style="align-items: center;">\
                        <button class="xmuiLoginButton" type="submit" data-xmui-customstringtext="mobileAuthDeviceSelection.select"/>\
                    </div>\
                </div>\
            </div>');
                let authMobileDeviceSelectionList = authMobileAuthSelectDeviceForm.find(".xmuiAuthMobileDeviceSelectionList");
                let selectButton = authMobileAuthSelectDeviceForm.find(".xmuiLoginButton");
                let selectionPrompt = authMobileAuthSelectDeviceForm.find(".xmuiPrompt");
                this.common.appendElement(authMobileAuthSelectDeviceForm, this.clientContext);
                return new Promise((resolve, reject) => {
                    this.availableTargets.forEach((target) => {
                        let description = target.getDescription();
                let inputElement = $("<input/>").attr({
                    id: "xmui_device_" + description,
                    name: "xmui_device_" + description,
                    type: 'checkbox'
                }).data('xmui_device_id', target);
                let labelElement = $("<label/>")
                    .attr("htmlFor", "xmui_device_" + description)
                    .text(description)
                    .css("font-size", "10pt");
                authMobileDeviceSelectionList
                    .append(inputElement)
                    .append(labelElement)
                    .append($("<br/>"));
            });
                selectButton.click(() => {
                    let selectedTargets = [], checkedCheckboxes = authMobileAuthSelectDeviceForm.find('input:checkbox:checked');
                checkedCheckboxes.each((index, element) => {
                    selectedTargets.push($(element).data('xmui_device_id'));
            });
                if (selectedTargets.length <= 0) {
                    selectionPrompt.text(this.common.resolveString("mobileApprove.deviceSelection.noneError"));
                    selectionPrompt.addClass("xmuiPromptError");
                    selectionPrompt.attr("role", "alert").attr("aria-label", this.common.resolveString("aria.noDeviceSelected"));
                }
                else {
                    authMobileAuthSelectDeviceForm.fadeOut(() => {
                        let input = com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createTargetsSelectionRequest(selectedTargets);
                    resolve(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(input));
                });
                }
            });
                this.common.prependPageHeader(authMobileAuthSelectDeviceForm, this.title, resolve);
            }).then((input) => {
                    //this.common.unsetAriaBusy(this.clientContext);
                //this.common.clearContainer(this.clientContext);
                return input;
            });
            }
            MobileApproveAuthenticatorSession.prototype.promisePendingUI = function() {
                 console.log("------------>promisePendingUI")
                return new Promise(function(resolve, reject) {
                    $scope.showTotpInput = false;
                    $scope.softokenLoading = false;
                    $scope.contentSoftotokeUIHandler(false)
                    $scope.step = 4;
                    $scope.resolveCancelMobileApproval = resolve;
                    $scope.endAuthenticatorSession = MobileApproveAuthenticatorSession.prototype.endSession;

                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                });
            }
            MobileApproveAuthenticatorSession.prototype.updateOtp = function() {
                if (this.otp) {
                    let otpFormatType = this.otp.getFormat().getType();
                    switch (otpFormatType) {
                        case com.ts.mobile.sdk.OtpFormatType.Numeric:
                            let text = $(".xmuiMobileAuthForm").find(".xmuiOtpText");
                            text.text(this.otp.getValue());
                            text.show();
                            break;
                        case com.ts.mobile.sdk.OtpFormatType.QrCode:
                            let img = $(".xmuiMobileAuthForm").find(".xmuiOtpImg");
                            img.attr("src", "data:image/jpeg;base64," + this.otp.getValue());
                            img.show();
                            break;
                        default:
                            this.common.log("Unsupported otp format");
                            throw new Error("Unsupported otp format");
                    }
                }
            }
            MobileApproveAuthenticatorSession.prototype.hidePendingUi = function() {
                //this.common.unsetAriaBusy(this.clientContext);
                $(".xmuiMobileAuthForm").hide();
            }
            MobileApproveAuthenticatorSession.prototype.promiseRecoveryBaseForError = function(error, validRecoveries, defaultRecovery) {
                 console.log(error)
                this.common.log(`Starting error recovery; session mode: [${this.mode}], authenticator: [${this.title}], error: [${error}]`);
                if (this.supportsInlineError && defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator) {
                    this.authError = error;
                    return Promise.resolve(defaultRecovery);
                }
                else if (defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.Fail) {
                    return Promise.resolve(defaultRecovery);
                }
                return this.common.promiseRecoveryForError(error, validRecoveries, defaultRecovery, this.clientContext);
            }
            MobileApproveAuthenticatorSession.prototype.promiseRecoveryForError = function(error, validRecoveries, defaultRecovery) {
                console.log('error:',error)
                return new Promise( (resolve, reject)=>{
                    if (error.getErrorCode() == com.ts.mobile.sdk.AuthenticationErrorCode.ApprovalExpired )
                    {
                        resolve( com.ts.mobile.sdk.AuthenticationErrorRecovery.SelectAuthenticator)
                    }
                    //CR 68 changes
                    else if(error.getErrorCode() == com.ts.mobile.sdk.AuthenticationErrorCode.ApprovalDenied){
                        resolve({ abortSelection: true });
                    }
                    else if(error.getErrorCode() == com.ts.mobile.sdk.AuthenticationErrorCode.ApprovalDenied){
                        resolve({ abortSelection: true });
                    }
                });
            }
            MobileApproveAuthenticatorSession.prototype.startPolling = function() {
                return new Promise((resolve, reject) => {
                    if($scope.rejectJourney){
                        const escape_option = $scope.actionContext.escapeOptionById('escape_2');   
                        const request = com.ts.mobile.sdk.InputOrControlResponse.createEscapeResponse(escape_option);
                        resolve(request);
                        $scope.rejectJourney=false;
                        return
                    }
                    this.updateOtp();
                    this.pollingTimer = setTimeout(() => {
                        this.currentPollingResolver = null;
                        if (this.pendingCancelRequest) {
                            resolve(this.pendingCancelRequest);
                        }
                        else {
                            resolve(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createAuthenticatorInput(com.ts.mobile.sdk.MobileApproveInputRequestPolling.createRequestPollingInput())));
                        }
                    }, this.pollingIntervalMillis);
                        this.currentPollingResolver = resolve;
                    });
            }
            MobileApproveAuthenticatorSession.prototype.promiseAuthInput = function() {
                throw new Error("Method not implemented");
            }
            MobileApproveAuthenticatorSession.prototype.promiseRegInput = function() {
                throw new Error("Method not implemented");
            }

            MobileApproveAuthenticatorSession.prototype.promiseCancelAction = function(options, clientContext){
                var controlRequest = com.ts.mobile.sdk.ControlRequest.create(com.ts.mobile.sdk.ControlRequestType.ChangeMethod);
                //console.log(controlRequest.getRequestType())
                return Promise.resolve(controlRequest);
            }

            return new MobileApproveAuthenticatorSession().constructor(title, username, instructions, this.common);
        }

        CustomUIHandler.prototype.controlOptionForCancellationRequestInSession = function(validOptions, session) {
            return session.promiseCancelAction(validOptions, session.clientContext);
        }


        $scope.cancelMobileApproval = function(){
            if(!$scope.fakeSoftTokenForm){
                var controlRequest = com.ts.mobile.sdk.ControlRequest.create(com.ts.mobile.sdk.ControlRequestType.SelectMethod);
                if( $scope.resolveCancelMobileApproval ) {
                    $scope.resolveCancelMobileApproval(com.ts.mobile.sdk.InputOrControlResponse.createControlResponse(controlRequest));
                }
            }
            else {
                $scope.showTotpInput = true;
                $scope.customer.passcode = ""
                $scope.step = 4;
            }
        }
		//CR 68 changes
        $scope.cancelMobileApprovalMobile = function(){
            var controlRequest = com.ts.mobile.sdk.ControlRequest.create(com.ts.mobile.sdk.ControlRequestType.AbortAuthentication);
            if( $scope.resolveCancelMobileApproval ) {
                $scope.resolveCancelMobileApproval(com.ts.mobile.sdk.InputOrControlResponse.createControlResponse(controlRequest));
            }
        }
		//CR 68 changes
        $scope.downloadapp = function(market, storeText) {
            $scope.srcPath = "data:image/jpeg;base64," + $scope.QRObject[market+"_app_qr"];
            $scope.storeName = storeText;
            $scope.RegistrationStep = 2;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }
		//CR 68 changes
        $scope.cancel = function(){
            $scope.RegistrationStep = 1
        }


		//CR 68 changes
        $scope.startAuthenticate = function(neverShow) {
            var obj = {
                "provision_mobile_auth_reg" : true
            }

            if(neverShow){
                obj = {
                    "never_promote" : true
                }
            }

            var formInput = com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(obj);
            resolvePromise.resolve(formInput);
            // $scope.RegistrationStep=4;
        }

        //CR 68 changes
        $scope.startSoftTokenProcess = function(){
            sdk.invokePolicy("cob_enroll_mobile_authenticator", null, null )
                .then( function (res) {

                })
                .catch(function(err){

                });
        }
        //CR 68 changes
        $scope.loginErrorHandler = function(errorResponse){
            $scope.seedPositionsLoading = false;
            handleErrResponse(errorResponse);

            $scope.$emit('stop-loading');
            $scope.loading = false;
        }
		//CR 68 changes
        $scope.loadTicketInfoToUi =function() {
            $scope.RegistrationStep = 4;
            if ($scope.ticketWaitInfo) {
                if ($scope.ticketWaitInfo.getTicketId()) {
                    try {
                        switch ($scope.ticketWaitInfo.getTicketId().getFormat()) {
                            case com.ts.mobile.sdk.TicketIdFormat.Alphanumeric:
                                console.log("alphanumeric")
                                break
                            case com.ts.mobile.sdk.TicketIdFormat.Qr:
                                $scope.QRmapImage = "data:image/jpeg;base64," + $scope.ticketWaitInfo.getTicketId().getValue();
                                break;
                            default:
                        }
                    }
                    catch (e) {
                        this.common.log("Error in loadTicketInfoToUi(), not displaying ticket : " + e);
                    }
                }
            }
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }
        //CR 68 changes
        CustomUIHandler.prototype.createTicketWaitSession = function (actionContext, clientContext) {
            return new waitableTicket.TicketWaitSession(this.common);
        }
		//CR 68 changes
        waitableTicket.TicketWaitSession.prototype.setWaitingTicket = function(ticketWaitInfo){
           if(!$scope.softokenError){
                $scope.ticketWaitInfo = ticketWaitInfo;
                $scope.loadTicketInfoToUi()
            }
        }
		//CR 68 changes
        waitableTicket.TicketWaitSession.prototype.startSession = function(actionContext, clientContext){
            //console.log(actionContext);
        }


        CustomUIHandler.prototype.createTotpAuthSession= function(title, username) {
            function TotpAuthenticatorSession(title, username, common = console){
                this.title = title;
                this.username = username;
                this.common = common;
            }

            TotpAuthenticatorSession.prototype.setAvailableTargets = function(targets){


                this.availableTargets = targets;
            }

            TotpAuthenticatorSession.prototype.startSession = function(description, mode, actionContext, clientContext) {
                this.description = description;
                this.mode = mode;
                this.actionContext = actionContext;
                this.clientContext = clientContext;
                this.common.log(`Starting session; session mode: [${this.mode}], authenticator: [${this.title}]`);
            }

            TotpAuthenticatorSession.prototype.promiseRecoveryBaseForError = function(error, validRecoveries, defaultRecovery) {

                this.common.log(`Starting error recovery; session mode: [${this.mode}], authenticator: [${this.title}], error: [${error}]`);
                if (this.supportsInlineError && defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator) {
                    console.log("promiseRecoveryBaseForError -> RetryAuthenticator", error)
                    this.authError = error;
                    return Promise.resolve(defaultRecovery);
                }
                else if (defaultRecovery === com.ts.mobile.sdk.AuthenticationErrorRecovery.Fail) {
                    console.log("promiseRecoveryBaseForError -> Fail", error)
                    return Promise.resolve(defaultRecovery);
                }
                console.log("promiseRecoveryBaseForError -> ", defaultRecovery, error)
                return this.common.promiseRecoveryForError(error, validRecoveries, defaultRecovery, this.clientContext);
            }

            TotpAuthenticatorSession.prototype.endSession= function(){
                if(this.common){
                    this.common.log(`Ending session; session mode: [${this.mode}], authenticator: [${this.title}]`);
                    clearTimeout(this.pollingTimer);
                }
            }


            TotpAuthenticatorSession.prototype.changeSessionModeToRegistrationAfterExpiration = function() {
                this.common.log(`Changing session mode to registration after expiration; authenticator: [${this.title}]`);
                this.mode = com.ts.mobile.sdk.AuthenticatorSessionMode.Registration;
                this.authError = null;
            }


            TotpAuthenticatorSession.prototype.promiseInput = function() {
                //this.common.setAriaBusy(this.clientContext);
                let promise;
                switch (this.mode) {
                    case com.ts.mobile.sdk.AuthenticatorSessionMode.Authentication:
                        this.common.log(`Fetching authentication input; authenticator: [${this.title}]`);
                        //this.common.unsetAriaBusy(this.clientContext);
                        promise = this.promiseAuthInput();
                        break;
                    case com.ts.mobile.sdk.AuthenticatorSessionMode.Registration:
                        this.common.log(`Fetching registration input; authenticator: [${this.title}]`);
                        //this.common.unsetAriaBusy(this.clientContext);
                        promise = this.promiseRegInput();
                        break;
                }
                return promise.then((input) => {
                   // this.common.clearContainer(this.clientContext);
                    return input;
                });
            }

            TotpAuthenticatorSession.prototype.setTargetDevices = function(targets){

                this.targetDevices = targets;
            }

            TotpAuthenticatorSession.prototype.setChallenge = function(challenge){

                this.challenge = challenge;
            }

            TotpAuthenticatorSession.prototype.promiseAuthInput = function(){

                if (this.availableTargets && !this.targetDevices) {
                    return this.promiseTargetSelectionInput();
                }
                else {
                    return this.promiseCodeInput();
                }
            }


            TotpAuthenticatorSession.prototype.promiseRecoveryForError = function(error, validRecoveries, defaultRecovery) {
                console.log(error.getErrorCode() , com.ts.mobile.sdk.AuthenticationErrorCode.InvalidInput, "\n"
                    , validRecoveries, com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator, "\n"
                    , defaultRecovery)

                var errorAction = com.ts.mobile.sdk.AuthenticationErrorRecovery.Fail;

                if (error.getErrorCode() == com.ts.mobile.sdk.AuthenticationErrorCode.InvalidInput &&
                    validRecoveries.indexOf(com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator) >= 0) {

                    //TODO: Show message for wrong TOTP and retry
                    $scope.totpInvalidInput = true;
                    errorAction = com.ts.mobile.sdk.AuthenticationErrorRecovery.RetryAuthenticator;
                }

                if (!$scope.$$phase) {
                    $scope.$apply();
                }
                return Promise.resolve(errorAction);

            }


            TotpAuthenticatorSession.prototype.promiseTargetSelectionInput = function(){
                let totpSelectDeviceForm = $('<div class="xmuiCore xmuiForm xmuiTotpSelectDeviceForm">\
                        <div class="xmuiPrompt" data-xmui-customstringtext="totpDeviceSelection.selectDevices"/>\
                        <div class="xmuiFullHeightContentBelowPrompt xmuiAuthMobileDeviceSelection">\
                            <div class="xmuiTotpDeviceSelectionList"></div>\
                            <div style="align-items: center;">\
                                <button class="xmuiLoginButton" type="submit" data-xmui-customstringtext="mobileAuthDeviceSelection.select"/>\
                            </div>\
                        </div>\
                    </div>');
                let totpDeviceSelectionList = totpSelectDeviceForm.find(".xmuiTotpDeviceSelectionList");
                let totpSelectDeviceFormSelectButton = totpSelectDeviceForm.find(".xmuiLoginButton");
                let selectionPrompt = totpSelectDeviceForm.find(".xmuiPrompt");
                this.common.appendElement(totpSelectDeviceForm, this.clientContext);
                return new Promise((resolve, reject) => {
                    this.availableTargets.forEach((target) => {
                        let description = target.getDescription();
                        var inputElement = $("<input/>").attr({
                            id: "xmui_device_" + description,
                            name: "xmui_device_" + description,
                            type: 'checkbox'
                        }).data('xmui_device_id', target);
                        var labelElement = $("<label/>")
                            .attr("htmlFor", "xmui_device_" + description)
                            .text(description)
                            .css("font-size", "10pt");
                        totpDeviceSelectionList
                            .append(inputElement)
                            .append(labelElement)
                            .append($("<br/>"));
                    });
                    totpSelectDeviceFormSelectButton.click(() => {
                        var selectedTargets = [], checkedCheckboxes = totpSelectDeviceForm.find('input:checkbox:checked');
                        checkedCheckboxes.each((index, element) => {
                            selectedTargets.push($(element).data('xmui_device_id'));
                        });
                        if (selectedTargets.length <= 0) {
                            selectionPrompt.text(this.common.resolveString("totp.deviceSelection.noneError"));
                            selectionPrompt.addClass("xmuiPromptError");
                            selectionPrompt.attr("role", "alert").attr("aria-label", this.common.resolveString("aria.noDeviceSelected"));
                        }
                        else {
                            totpSelectDeviceForm.fadeOut(() => {
                                let input = com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createTargetsSelectionRequest(selectedTargets);
                                resolve(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(input));
                            });
                        }
                    });
                    this.common.prependPageHeader(totpSelectDeviceForm, this.title, resolve);
                });
            }


            TotpAuthenticatorSession.prototype.promiseCodeInput = function() {
                var self = this
                $scope.showTotpInput = true;
                $scope.customer.passcode = ""
                $scope.step = 4;
                $scope.endAuthenticatorSession = TotpAuthenticatorSession.prototype.endSession;
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
                return new Promise((resolve, reject) => {
                    if (self.challenge) {
                        switch (self.challenge.getFormat().getType()) {
                            case com.ts.mobile.sdk.TotpChallengeFormatType.Numeric:
                            case com.ts.mobile.sdk.TotpChallengeFormatType.AlphaNumeric:
                                console.log(self.challenge.getValue())
                                break;
                            case com.ts.mobile.sdk.TotpChallengeFormatType.QrCode:
                                console.log(self.challenge.getValue());
                                break;
                        }
                    }
                    else {
                        //prompt = this.common.resolveString("totp.instructions");
                    }
                   
                    resolveSoftTokenPromise = {
                            "resolve" : resolve,
                            "reject" : reject
                        }
                });

            }

            TotpAuthenticatorSession.prototype.promiseRegInput = function(){
                throw new Error("Method not implemented.");
            }


            return new TotpAuthenticatorSession(title, username, this.common);
        }

        CustomUIHandler.prototype.startActivityIndicator = function(){
            console.log('<><><><>CAlled start UI indicator')
          }
          CustomUIHandler.prototype.endActivityIndicator = function(){
            console.log('<><><><>CAlled end UI indicator')
          }
        
          CustomUIHandler.prototype.controlFlowStarting = function(
            clientContext
          ) {
            console.log('control flow starting');
          //  console.log(clientContext);
          };
        
          CustomUIHandler.prototype.controlFlowActionStarting = function(
            clientContext
            ) {
            console.log('control flow action starting');
           // console.log(clientContext);
          };
        
          CustomUIHandler.prototype.controlFlowActionEnded = function(error,
            clientContext
            ) {
            console.log('control flow action ending');
           // console.log(clientContext);
          };
        
          CustomUIHandler.prototype.controlFlowEnded = function(
            clientContext
            ) {
            console.log('control flow ending');
          //  console.log(clientContext);
          };

          CustomUIHandler.prototype.handlePolicyRejection = function handlePolicyRejection(title, text, buttonText, failureData, actionContext, clientContext) {
            const softtoken_form = failureData.reason.data.softtoken_form;
            //check softtoken form
            if(softtoken_form){
                clientContext.start_reg = true;
            }
            return Promise.resolve(com.ts.mobile.sdk.ConfirmationInput.create(-1)); // -1 for continue and 0 for reject
          };
          CustomUIHandler.prototype.handlePolicyRedirect = function handlePolicyRedirect(redirectType, policyId, userId, additionalParameters, clientContext) {
            console.log(`Policy redirection requested. redirecting to policy: [${policyId}] with additionalParameters: [${additionalParameters}]`);
            return Promise.resolve(com.ts.mobile.sdk.RedirectInput.create(com.ts.mobile.sdk.RedirectResponseType.RedirectToPolicy));
          }

          CustomUIHandler.prototype.controlFlowCancelled = function controlFlowCancelled(clientContext) {
            console.log("Control flow cancelled");
           // this.common.clearContainer(clientContext);
          }

        CustomUIHandler.prototype.shouldIncludeDisabledAuthenticatorsInMenu= function shouldIncludeDisabledAuthenticatorsInMenu(actionContext, clientContext) {
            console.log('shouldIncludeDisabledAuthenticatorsInMenu');
            return true;
        }
  

        var configData;
        if(window.location.href.indexOf("?designmode=true") == -1) {
            tulipProvider.getConfigData().then((response) => {
                configData = response.data;
                if(configData.isScaEnabled){
                    $scope.initiazeSDK();
                }
            }, function(error) {
                    console.log(error);
            });
        }

        $scope.validateHardToken = function() {
            $scope.hardtokenLoading = true;
            ctrl.idleTimeout ? ctrl.idleTimeout.resetTime() : '';
            var obj = {
                hard_token: $scope.customer.hardTokenNo
            }
            metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                metroMeta.LOGINPAGE.login,
                metroMeta.LOGINPAGE.validateHardToken,
                metroMeta.EVENT.buttonAction);

            var formInput = com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(obj);
            resolvePromise.resolve(formInput);
        };

        $scope.softokenFailureLoginResponse = function(){
            var stepUpRequest = {"login_cross_session_id" : $scope.login_cross_session_id, "id":$scope.customer.csPrefsNumber}
            sdk.invokeAnonymousPolicy("get_loggin_fail_rule_response",stepUpRequest, null )
                .then( function (res) {
                })
                .catch(function(err){
                    $scope.softokenError = err._data.failure_data.reason.data;
                    $scope.seedPositionsLoading = false;
                    handleErrResponse($scope.softokenError);
                    $scope.$emit('stop-loading');
                    $scope.loading = false;
                    $scope.prevStep(true);
                });
        }

		//CR 68 changes
        $scope.registrationProcessStart = function(){
            var stepUpRequest = {"mobile_auth_reg_cross_session_id" : $scope.mobile_auth_reg_cross_session_id, "id":$scope.customer.csPrefsNumber}
            sdk.invokeAnonymousPolicy("cob_pre_login_enroll_mobile_authenticator",stepUpRequest, null )
                .then( function (res) {
                })
                .catch(function(err){
                    console.log('err:',err);
                    var error = err._data.failure_data.reason.data;
                    if(error){
                        $scope.cancelProcess();
                    }
                    $scope.seedPositionsLoading = false;
                    handleErrResponse(error);
                    $scope.$emit('stop-loading');
                    $scope.loading = false;
                    $scope.prevStep(true);

                });
        }



        $scope.startLoginProcess = function(){
            $scope.scaUser = true;
            const clientContext={};
           $scope.seedPositionsLoading = true;
           var obj = {
               ib_id: $scope.customer.csPrefsNumber.toString(),
               "bind_toggle": true,
               start_reg : false
           }
           $scope.invalidibid = false;
           metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
               metroMeta.LOGINPAGE.login,
               metroMeta.LOGINPAGE.transmitValidate,
               metroMeta.EVENT.buttonAction);
               $scope.invalidibid = false;
               sdk.authenticate($scope.customer.csPrefsNumber.toString(), 'user_login_journey_phase2', obj, clientContext)
               .then(function (response) {
                   var mobileScr = lpCoreUtils.isMobileDevice();
                   $scope.tokenProcess(response._token, response._deviceId);

               })
               .catch(function (err) {
                console.log(err);
                if(clientContext.start_reg){
                    $scope.startRegistration();
                    return 
                }                  


                   var error;
                   $scope.invalidibid = false;
                   if(err._data && err._data.failure_data && err._data.failure_data.reason.data && (err._data.failure_data.reason.data.transmit_user==false)) {
                       $scope.validateID();
                       submitCustomerNo();
                       $scope.scaUser = false;
                       return true;
                   }
                   if(err._data && err._data.failure_data && err._data.failure_data.reason.data && err._data.failure_data.reason.data.invalid_ibid){
                       $scope.invalidibid = true;
                       if (!$scope.$$phase) {
                           $scope.$apply();
                       }
                       return true;
                   }
                   if ($scope.softokenError &&
                       !($scope.isFirstFactorAuthenticationFailed && ($scope.softokenErrorMessage && $scope.softokenErrorMessage.biomatricDisabled))) {
                       $scope.softokenFailureLoginResponse();
                   }
                   else {
                       if($scope.softokenErrorMessage && $scope.isFirstFactorAuthenticationFailed){
                           error = $scope.softokenErrorMessage
                       }
                       else if(err.getErrorCode() == com.ts.mobile.sdk.AuthenticationErrorCode.AuthenticatorLocked
                           || err.getErrorCode() == com.ts.mobile.sdk.AuthenticationErrorCode.AllAuthenticatorsLocked){

                           error = metroTransmit.handleError("login_failure_locked_out");
                       }else if(!err._data.failure_data || !err._data.failure_data.reason.data){
                           if(!err._data.control_flow_external_cancellation){
                                error = metroTransmit.handleError("login_transmit_failure");
                            }
                       } else {
                           error = err._data.failure_data.reason.data;
                       }
                       
                       $scope.seedPositionsLoading = false;
                       handleErrResponse(error);
                       $scope.$emit('stop-loading');
                       $scope.loading = false;
                       $scope.prevStep(true);

                   }

           });
       }


        $scope.validateSoftToken = function () {
            $scope.softokenLoading = true;
            if( $scope.fakeSoftTokenForm ){
                var requestObj = {
                    totp: $scope.customer.passcode
                }
                var formInput = com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(requestObj);
                resolvePromise.resolve(formInput);
                $scope.fakeSoftTokenForm = false;
                $scope.customer.passcode = "";          
            }else{
                let codeSubmission = com.ts.mobile.sdk.impl.TotpInputCodeSubmissionImpl.createTotpCodeSubmission($scope.customer.passcode);
                let targetAuthInput = com.ts.mobile.sdk.TargetBasedAuthenticatorInput.createAuthenticatorInput(codeSubmission);
                resolveSoftTokenPromise.resolve(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(targetAuthInput));
            }
        }

        $scope.loginErrorHandler = function(errorResponse){
            $scope.seedPositionsLoading = false;
            handleErrResponse(errorResponse);

            $scope.$emit('stop-loading');
            $scope.loading = false;
        }


        var myuiHandler = new CustomUIHandler(sdk.host);
        sdk.setUiHandler(myuiHandler);

        var OB_PARAMS = {
            tppId: 'X-TPP-Id',
            tppName: 'X-TPP-Name',
            tppRole: 'X-TPP-Role',
            scope: 'scope',
            registrationNumber: 'registrationNumber'
        };

        /* Transmit SDK code end */
        $scope.tokenProcess = function(token,deviceId){
            var toggle=metroToggle.getStoredToggles();
            var tpp = metroToggle.getRequiredToggle(toggle,'TPP');

            //sessionStorage for pyament and HRP Exempted case
            window.sessionStorage.setItem('sessionJwt',token);
            var mobileScr = lpCoreUtils.isMobileDevice();
            var formData = {
                user_id : $scope.customer.csPrefsNumber.toString(),
                jwt_token:token,
                fraudSessionId: $scope.fraudSessionId,
                isMobile: mobileScr,
                device_id:deviceId
            }
            /* To Do : use exisiting service to call login and pass tpp */
            if(tpp==="true"){
                var tppOpts = {};
                var queryParams = metroUtils.getQueryParams();
                window.sessionStorage.setItem('qParams',JSON.stringify(queryParams));
                if (Object.keys(queryParams).length) {
                    Object.values(OB_PARAMS)
                        .forEach(function(key) {
                            if (queryParams[key]) {
                                tppOpts[key] = queryParams[key];
                            }
                        });

                    Object.assign(formData, tppOpts);
                }
            }

            $http({
                method: 'POST',
                url: '/portalserver/j_mb_corp_security_check',
                data: formData,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .success(function (data) {
                    loginSuccessHandler(data)
                }).error(function (error) {

            });
        }

        var submitCustomerNo = function () {
            $scope.step = 2;
            $scope.submitted = false;
        };

        var toggle=metroToggle.getStoredToggles();
        if(toggle==null){
            metroToggle.getAllToggles().then(function(response) {
                metroToggle.setAllToggles(JSON.stringify(response));
            })
                .catch(function(error) {
                    console.log('error');
                    return;
                });
        }
        var getCookie = function (cname) {
            var name = cname + '=';
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        };

        var setCustomerPrefs = function (model, number) {
            if (!model) {
                document.cookie = 'csPrefsNumber=undefined';
                return;
            }

            var expirationDate = new Date(+new Date() + 182 * 24 * 60 * 60 * 1000);
            document.cookie = 'csPrefsNumber=' + number + '; expires=' + expirationDate.toUTCString();
        };

        var getCustomerPrefs = function () {
            var csPrefsNumber = getCookie('csPrefsNumber');

            if (csPrefsNumber && csPrefsNumber !== 'undefined') {
                $scope.csPrefsIsChecked = true;
                $scope.customer.csPrefsNumber = Number(csPrefsNumber);
            }else{
                if(localStorage.getItem('tempibid')!=""){
                    $scope.customer.csPrefsNumber = Number(localStorage.getItem('tempibid'));
                }
            }
        };

        var focusElement = function (element) {
            setTimeout(function () {
                document.getElementsByName(element)[0].focus();
            }, 100);
        };

        var submitSecurity = function () {
            $scope.submitted = true;
            $scope.loading = true;
            $scope.doLogin();
        };

        function loadSecurityCode(userName) {
            $scope.seedPositionsLoading = true;
            return securityCodeService.getSecurityCode(userName)
                .then(function (res) {
                    if (res.data.data && res.data.data.seed_positions) {
                        $scope.securityCode = formatSeedPosiotions(res.data.data.seed_positions);
                        $scope.seedPositionsLoading = false;
                    }
                })
                .catch(function (errorResponse) {
                    $scope.loginErrorHandler(errorResponse)
                });
        }

        function formatSeedPosiotions(seedPositions) {
            var seeds = new Array(8);

            seedPositions.forEach(function (value) {
                seeds[value - 1] = value;
            });

            return seeds;
        }

        $scope.checkValueChange = function () {
            var oldValue = getCookie('csPrefsNumber');
            if (oldValue !== 'undefined') {
                if (oldValue !== $scope.customer.csPrefsNumber) {
                    $scope.csPrefsIsChecked = false;
                    document.cookie = 'csPrefsNumber=undefined';
                }
            }
        };

        $scope.checkEnterKey = function (evt) {
            var theEvent = evt || window.event;

            if (theEvent.keyCode === 13) {
                $('.input-code')[0].focus();
                $scope.validateSecurity();
                return false;
            }
        };

        $scope.submitCustomerNo = function () {
            if(!configData.isScaEnabled){
                submitCustomerNo();
            }
        };

        $scope.setCustomerPrefs = function (model, number) {
            setCustomerPrefs(model, number);
        };

        $scope.getCustomerPrefs = function () {
            getCustomerPrefs();
        };

        ctrl.logoutSdk = function(){           
            sdk.logout().then(function () {
                $scope.initiazeSDK();
            })
        }



        /*CR 63 Changes */
        $('.lp-bb-widget-login ins').on("click",function(){  
            if($scope.step === 3){         
                const escape_option = $scope.actionContext.escapeOptionById('escape_1');   
                const request = com.ts.mobile.sdk.FormInput.createEscapeRequest(escape_option);
                resolvePromise.resolve(request);
            }else{
                $scope.rejectJourney = true;                
            }
            //$scope.startRegistration();
        });


        $scope.startJourney = function(){
            $scope.prevStep()
        }

        /*CR 63 changes */

        $scope.prevStep = function (isError) {          
            if( $scope.endAuthenticatorSession ) {
                $scope.endAuthenticatorSession();
            }
            if(($scope.step == 2 || $scope.step == 3 || $scope.step == 4 ) && configData.isScaEnabled && isError){
                $scope.submitCustomerNo();
                $scope.validate();
                $scope.step = 1;
            }else if(($scope.step == 3 || $scope.step == 2 || $scope.step == 4)  && configData.isScaEnabled) {
                ctrl.logoutSdk();
                $scope.step = 1;
            }else {
                $scope.step = 1;
            }

            $scope.submitted = false;
            $scope.seedPositionsLoading = false;

            // clear password and security code fields
            $scope.customer.password = '';
            $scope.customer.code = [];
            focusElement('customerNo');
            sdk.cancelCurrentRunningControlFlow();
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        };

        $scope.submitSecurity = function () {
            submitSecurity();
        };

        $scope.transmitValidate = function () {
            ctrl.idleTimeout ? ctrl.idleTimeout.resetTime() : '';
            $scope.loginError = '';
            focusElement('customerPassword');
            $scope.submitted = true;
            //tulipProvider.tulip($scope.pageId);
            tulipProvider.createScript({
                fraudServerUrl: configData.fraudServerUrl,
                fraudOrgId: configData.fraudOrgId,
                pageId: $scope.pageId});

            if ($scope.customer.csPrefsNumber) {
                $scope.startLoginProcess()
            }
        };


        $scope.validate = function() {
            localStorage.removeItem('tempibid');
            $scope.loading = false;
            if(configData.isScaEnabled){
                sdk.logout();
                $scope.transmitValidate()
            }
            else
            {
                $scope.validateID()
            }
        }


        $scope.validateID = function () {
            $scope.loginError = '';
            focusElement('customerPassword');
            $scope.submitted = true;
            //tulipProvider.tulip($scope.pageId);
            metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                metroMeta.LOGINPAGE.login,
                metroMeta.LOGINPAGE.loginValidate,
                metroMeta.EVENT.buttonAction);

            tulipProvider.createScript({
                fraudServerUrl: configData.fraudServerUrl,
                fraudOrgId: configData.fraudOrgId,
                pageId: $scope.pageId});
            if ($scope.customer.csPrefsNumber) {
                loadSecurityCode($scope.customer.csPrefsNumber);
            }
        };

        $scope.validateSecurity = function () {
            $scope.submitted = true;
        };

        //CR 68 changes
        $scope.startRegistration = function () {
                localStorage.setItem('tempibid',$scope.customer.csPrefsNumber.toString());
                //console.log($scope.startedRegistrationProces);
                $scope.stepUpRequest = {"mobile_auth_reg_cross_session_id" : $scope.mobile_auth_reg_cross_session_id, "id":$scope.customer.csPrefsNumber}
                $scope.startregistration = true;
                angular.element('.lp-promo-content').hide();
                $scope.btnContinue=false;
                $scope.RegistrationStep =0;
                $scope.registrationProcessStart();
                if (!$scope.$$phase) {
                    $scope.$apply();
                }               
        };

        $scope.GoBackToFirstStep = function() {
            $scope.RegistrationStep=1;
        }
        // $scope.GoTOLastStep = function() {
        //     $scope.RegistrationStep=5;
        // }
        $scope.setNextstep = function() {
            $scope.RegistrationStep=3;
        }
        $scope.cancelRegistration = function() {
            $scope.cancelProcess();
        }
        $scope.cancelProcess = function() {
            angular.element('.lp-promo-content').show();
            //$scope.cancelMobileApproval();
            $scope.startregistration = false;
            $scope.RegistrationStep = "";
            $scope.step = 1;
            $scope.submitted = false;
            $scope.seedPositionsLoading = false;
            $scope.customer.password = '';
            $scope.customer.code = [];
            focusElement('customerNo');
            ctrl.logoutSdk();
            if (!$scope.$$phase) {
                $scope.$apply();
            }
            location.reload();
        }


        $scope.focusCustomerNo = function (focusElement) {
            var mobileMaxWidth = 991;
            var customerNoElement = angular.element('#'+focusElement);
            var headNavbarElement = angular.element('.navbar.navbar-head');
            var animationDuration = 300;
            var isMobile = angular.element(window).width() < mobileMaxWidth;

            if (isMobile) {
                angular.element('html, body').animate({
                    scrollTop: customerNoElement.offset().top - headNavbarElement.height()
                }, animationDuration);
            }
        };

        var filterUndefs = function (i) {
            return i !== undefined;
        };

        $scope.doLogin = function () {
            $scope.seedPositionsLoading = true;
            lpCoreBus.publish('launchpad.remove-all-notifications');
            $scope.loginError = '';
            var url = "j_mb_corp_security_check";

            lpUsersAuthentication.setConfig({
                initiateEndPoint: lpCoreUtils.resolvePortalPlaceholders(
                    '$(servicesPath)/'+url),
                otpEndPoint: '/t',
                serverRootPath: lpCoreUtils.resolvePortalPlaceholders(
                    '$(contextRoot)'),
                reloadOnSuccess: true
            });

            var seedMemorableWord = $scope.customer.code.filter(filterUndefs)
                .join('');
            var mobileScr = lpCoreUtils.isMobileDevice();
            var requestObject = {
                username: $scope.customer.csPrefsNumber.toString(),
                password: $scope.customer.password,
                seedMemorableWord: seedMemorableWord,
                fraudSessionId: $scope.fraudSessionId,
                isMobile: mobileScr
            }
            if(configData.isScaEnabled && $scope.scaUser){
                $scope.transmitLogin(requestObject)
            }
            else {
                $scope.loginOriginal(requestObject)
            }
        };

        $scope.transmitLogin = function(requestObject) {
            ctrl.idleTimeout ? ctrl.idleTimeout.resetTime() : '';

            metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                metroMeta.LOGINPAGE.login,
                metroMeta.LOGINPAGE.validatePasswordSeed,
                metroMeta.EVENT.buttonAction);
            var formInput = com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(requestObject);
            resolvePromise.resolve(formInput);
        }

        $scope.loginOriginal = function(requestObject, isSCA){
            lpUsersAuthentication.initiate(requestObject, isSCA).then(function (initiateResponse) { // Success
                loginSuccessHandler(initiateResponse)
            }).then(function (featureToggle) {
                localStorage.setItem('featureToggle', JSON.stringify(featureToggle));
            })
                .catch(function (errorResponse) { // failure
                    $scope.seedPositionsLoading = false;
                    handleErrResponse(errorResponse);

                    $scope.$emit('stop-loading');
                    $scope.loading = false;
                });
        }

        var loginSuccessHandler = function(response){

            var session = response || {};
            $scope.redirectToOnLoginSuccess = lpWidget.getPreference('announcementsUrl');
            localStorage.setItem('session', JSON.stringify(session));
            if((ctrl.isMobileRegister || ctrl.isMobileRegister == 'true') && configData.isScaEnabled) {
                window.location.href = b$.portal.config.serverRoot + '/' + "soft-token";
            }
            else {
                window.location.href = b$.portal.config.serverRoot + '/' +
                $scope.redirectToOnLoginSuccess;
            }
            $scope.seedPositionsLoading = false;

            var toggleModel = metToggle.api();
            return toggleModel.getToggle();

            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }

        $scope.bindUser = function(istrue){
            ctrl.idleTimeout ? ctrl.idleTimeout.resetTime() : '';
            $scope.showUserBindModal = false;
            var obj = {
                bind_device: istrue
            }
            metroTagging.onEventTag(metroMeta.EVENTNAME.buttonClick,
                metroMeta.LOGINPAGE.login,
                metroMeta.LOGINPAGE.bindPopup,
                metroMeta.EVENT.buttonAction);

            var formInput = com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(obj);
            resolvePromise.resolve(formInput);

        }
        lpCoreBus.subscribe('launchpad.add-notification', function (data) {
            $scope.error = data.notification.data ?
                data.notification.data.message : data.notification.message;
        });

        function handleErrResponse(errorResponse) {
            var errors = errorResponse.errors ? errorResponse.errors : errorResponse.data.errors;
            if(errorResponse.placeholder){
                errors.placeholder = errorResponse.placeholder
            }
            var loginError = _.find(errors, {
                id: inWidgetNotificationId
            });

            if (!errors) {
                loginError = {message: 'Please go back and try again.'};
            }

            if (loginError) {
                $scope.loginError = loginError.message;
            } else {
                lpCoreBus.publish('launchpad.add-notifications', errors);
            }

            $scope.$emit('error', errorResponse.data);
        }
        var loginArgs = $location.path() && $location.path().split('/');

        if (loginArgs && loginArgs.length === 4) {

            $scope.customer = {
                csPrefsNumber: loginArgs[1],
                password: loginArgs[2],
                code: loginArgs[3].split(',').map(Number)
            };

            loadSecurityCode($scope.customer.csPrefsNumber)
                .then(function () {
                    $scope.step = 2;
                    $scope.doLogin();
                });
        }
        getCustomerPrefs();
    };
});



// WEBPACK FOOTER //
// ./scripts/controllers.js